import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';
import PricingDeploymentContent from '../components/Pricing/PricingDeploymentContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/language/selector';


const PricingDeployment = () => {
        const {t} = useTranslation()
    
        const language = useSelector(selectLanguage)
    
        useEffect(() => {
            document.title = t('pricing_deployment.title')
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[language])
  return (
    <>
        <NavbarTop/>
        <PricingDeploymentContent/>
    </>
  )
}

export default PricingDeployment